import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { ISponsorClient, ISponsorEvent } from '../models/sponsor';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SponsorProvider {

  constructor(
    private afDatabase: AngularFireDatabase,
  ) { }

  getSponsorsClient(clientId: string): Observable<ISponsorClient[]> {
    return this.afDatabase.list<ISponsorClient>(`/ClientList/${clientId}/Sponsor`, ref => ref.orderByChild('state').equalTo(true)).valueChanges();
  }

  getSponsorsEvent(clientId: string, eventId: string): Observable<ISponsorEvent[]> {
    return this.afDatabase.list<ISponsorEvent>(`/Clients/${clientId}/Events/${eventId}/Sponsor`, ref => ref.orderByChild('state').equalTo(true)).valueChanges();
  }

  getSponsorMaster(clientId: string, id: string): any {
    return this.afDatabase.object(`Clients/${clientId}/Sponsors/${id}`).valueChanges();
  }
}


// WEBPACK FOOTER //
// ./src/providers/sponsor.ts